<template>
  <div style="display: flex; align-items: center; justify-content: center; height: 100%;">
    <div class="text-center">
      <h1>NOT FOUND</h1>
      <h2>{{$route.path}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      ruta: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
